import { fromJS } from 'immutable';
var config = function config(conf) {
  return function () {
    return fromJS(conf);
  };
};
export default config;